export const validateDomain = (domain: string, apiEndpointDomain: string, supportedDomains: string[] = []): boolean =>
    supportedDomains.includes("*") ||
    supportedDomains
        .map((supportedDomain: string) =>
            supportedDomain.toLowerCase().replace(/^/, "^").replace(".", ".").replace("*", ".*").concat("$")
        )
        .concat([`.*${apiEndpointDomain}`])
        .some((domainStringRegexp: string) => new RegExp(domainStringRegexp).test(domain));
